import { useState } from "react";
import Button from "../components/Button";
import { getCode, getCurrentUser } from "../services/Apis";
import SortTable from "../components/SortTable";
import { useNavigate } from "react-router-dom";

function AdminPage() {
  const [code, setCode] = useState("");
  const [data, setData] = useState([]);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  // const [error, setError] = useState(null);

  const options = {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
    timeZone: "UTC",
  };

  const config = [
    {
      label: "User",
      render: (item) => item.User,
      sortValue: (item) => item.User,
    },
    {
      label: "Answered At",
      render: (item) => {
        const date = new Date(item.Answered_At);
        var greeceTime = date.toLocaleString("en-US", options);
        return greeceTime + " (UTC)";
      },
      sortValue: (item) => item.Answered_At,
    },
    {
      label: "Updated At",
      render: (item) => {
        const date = new Date(item.Updated_At);
        var greeceTime = date.toLocaleString("en-US", options);
        return greeceTime + " (UTC)";
      },
      sortValue: (item) => item.Updated_At,
    },
    {
      label: "Pre / Post",
      render: (item) => item.Pre_Post,
      sortValue: (item) => item.Pre_Post,
    },
    {
      label: "Question",
      render: (item) => item.Question,
      sortValue: (item) => item.Question,
    },
    {
      label: "Answer",
      render: (item) => item.Answer,
      sortValue: (item) => item.Answer,
    },
  ];

  const handleExport = () => {
    if (getCurrentUser() == null) {
      navigate("/login");
    }
    const header = Object.keys(data[0]).slice(1); // Exclude the first column from the header
    let csv = data.map((row) =>
      header.map((fieldName) => JSON.stringify(row[fieldName])).join(",")
    );
    csv.unshift(header.join(","));
    csv = csv.join("\r\n");
  
    const csvData = "data:text/csv;charset=utf-8," + encodeURIComponent(csv);
    const link = document.createElement("a");
    const fileName = prompt("Enter a file name", "data.csv"); // Prompt user for file name
    if (fileName === null) {
      return;
    }
    link.setAttribute("href", csvData);
    link.setAttribute("download", fileName); // Use the entered file name
    link.click();
  };

  function validateForm() {
    return code.length === 4;
  };

  async function handleSubmit(event) {
    if (getCurrentUser() == null) {
      navigate("/login");
    }
    event.preventDefault();
    setError(null);
    const res = await getCode(code);
    if (res === "Classroom not found") return setError(res);
    if (res != null) {
      setData(res);
    }
  };

  const handleChangeCode = (event) => {
    setCode(event.target.value);
  };

  const keyFn = (item) => {
    return item.num_row;
  };

  return (
    <div className="mt-10">
      <h1 className="text-center text-2xl mb-10">Welcome to Admin Page</h1>
      <form onSubmit={handleSubmit}>
        <div className="flex flex-col items-center text-center ">
          <label className="text-blue-500">Type the 4 digit Code:</label>
          <input
            maxLength="4"
            autoFocus
            className="border-solid border-2 pl-7 pr-7 mr-auto ml-auto text-center "
            value={code}
            onChange={handleChangeCode}
          />
          <div className="flex justify-end">
            <Button
              primary
              outline={!validateForm()}
              rounded
              disabled={!validateForm()}
              type="submit"
              className={ validateForm() ?"mt-5 active:translate-y-1": "mt-5"}              
            >
              Submit
            </Button>
          </div>
        </div>
      </form>

      <div className="flex-col flex justify-center items-center mt-5">
        {error === "Classroom not found" ? (
          <div className="mb-2 text-red-500"> {error}</div>
        ) : (
          <br></br>
        )}
        {data.length === 0 ? (
          <div>
            There are no data to display, enter a Code.
          </div>
        ) : (
          <div className=" flex justify-center flex-col items-center  mt-10 mb-20 ">
            <div className="flex justify-center mb-5">
              <Button className={ validateForm() ?"active:translate-y-1": ""}  success onClick={handleExport}>
                Export table to CSV
              </Button>
            </div>
            <SortTable data={data} config={config} keyFn={keyFn} />
          </div>
        )}
      </div>
    </div>
  );
};

export default AdminPage;
